export const validateMandatory = (value) => {
  if (value && value.length > 0) {
    return true;
  }
  return false;
};

export const validatePostalCodeLength = (value, country) => {
  switch (country) {
    case 'NO': {
      if (value.length !== 4) {
        return false;
      }
      return /^\d+$/.test(value);
    }
    case 'SE': {
      if (value.length !== 5) {
        return false;
      }
      return /^\d+$/.test(value);
    }
    case 'DK': {
      if (value.length !== 4) {
        return false;
      }
      return true;
    }
    case 'CH': {
      if (value.length !== 4) {
        return false;
      }
      return true;
    }
    case 'DE': {
      if (value.length !== 5) {
        return false;
      }
      return true;
    }
    case 'ES': {
      if (value.length !== 5) {
        return false;
      }
      return true;
    }
    case 'IT': {
      if (value.length !== 5) {
        return false;
      }
      return true;
    }
    case 'FR': {
      return value.length === 5;
    }
    case 'PT': {
      return value.length === 4;
    }
    case 'NL': {
      if (value.length === 6) {
        return false;
      } else if (value.length === 4) {
        return false;
      }
      return true;
    }
    case 'IE': {
      return true;
    }
    case 'AT': {
      return value.length === 4;
    }
    // No known postcode format: accept rather than throw, since a throw here takes down the whole form
    default: {
      return true;
    }
  }
};
